import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ApiClientConstant } from '@cureskin/api-client';
import { CsIconModule } from '@components/icon';

/**
 * Banner shown on the unpaid regimen page (under the `restart_regimen_chat_UI` experiment)
 * inviting the user to re-answer the consultation questions. Tapping it asks the parent to
 * open the {@link ChangeRegimenAnswerBottomsheetComponent} confirmation sheet.
 */
@Component({
  selector: 'app-reanswer-regimen-question-banner',
  templateUrl: './reanswer-regimen-question-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CsIconModule],
})
export class ReanswerRegimenQuestionBannerComponent {
  /** Regimen class (FACE / HAIR) — drives the dynamic Skin/Hair copy. */
  readonly regimenClass = input.required<string>();

  /** Emitted when the user taps the banner to re-answer the questions. */
  readonly reanswerClick = output<void>();

  protected readonly isFaceRegimen = computed(
    (): boolean => this.regimenClass() === ApiClientConstant.Regimen.Class.FACE,
  );

  protected onClick(): void {
    this.reanswerClick.emit();
  }
}
